import React from 'react';
import { Box, TextSmall } from '@teamleader/ui';
import { translate } from '@teamleader/i18n';
import generalStyles from '../styles.css';
import LoginWithIdentityProviderButton from './LoginWithIdentityProviderButton';
import { IdentityProvider } from './types';
import styles from './styles.css';
import useFeatureFlag from '../../../Infrastructure/FeatureFlags/useFeatureFlag';
import FeatureFlags from '../../../Infrastructure/FeatureFlags/FeatureFlags';

const LoginWithIdentityProvider = () => {
  const hasAppleIdentityProviderFlagEnabled = useFeatureFlag(FeatureFlags.EnableAppleIdentityProvider);
  const hasMicrosoftIdentityProviderFlagEnabled = useFeatureFlag(FeatureFlags.EnableMicrosoftIdentityProvider);

  const identityProviders = Object.values(IdentityProvider).filter((identityProvider) => {
    if (!hasAppleIdentityProviderFlagEnabled && identityProvider === IdentityProvider.Apple) {
      return false;
    }
    if (!hasMicrosoftIdentityProviderFlagEnabled && identityProvider === IdentityProvider.Microsoft) {
      return false;
    }
    return true;
  });

  return (
    <Box marginTop={4} marginBottom={3}>
      <Box className={styles['identity-provider-buttons']} display="flex" flexDirection="row" marginBottom={3}>
        {identityProviders.map((identityProvider) => (
          <LoginWithIdentityProviderButton
            key={identityProvider}
            identityProvider={identityProvider}
            isFullText={!hasAppleIdentityProviderFlagEnabled && !hasMicrosoftIdentityProviderFlagEnabled}
          />
        ))}
      </Box>
      <Box display="flex">
        <TextSmall className={generalStyles['or-login-with-divider']}>{translate('orLoginWith')}</TextSmall>
      </Box>
    </Box>
  );
};

export default LoginWithIdentityProvider;
